export default "__VITE_ASSET__CSLezZSP__"